import { push } from 'connected-react-router';

import { generatePath } from 'bento-ordering/utils/generatePath';
import { closeModal } from 'bento-ordering/base/actions/modal';

import { MENU } from 'bento-ordering/menus/constants/entities';
import { CART } from 'bento-ordering/cart/constants/entities';
import { CART_BASE } from 'bento-ordering/cart/constants/paths';

export const closeEditCartForm = previousLocation => (dispatch, getState) => {
  const { cart } = getState();
  const id = cart.online_ordering_location;

  /** close cart on / or /cart.
   * / refers to when user open through modal
   * /cart refers to when user open through route
   */
  if (previousLocation.includes(CART_BASE)) {
    dispatch(push(generatePath(CART, 'cart')));
  } else {
    dispatch(closeModal());
    dispatch(push(generatePath(MENU, 'menu', { id })));
  }
};
